<template>
    <div class="slideout-panel-content">
        <div class="content" :class="{'teacher-mobile-padding': isTeacherView}">
            <slot name="header"></slot>
            <slot name="content"></slot>
            <slot name="footer-nav" v-if="$slots['footer']">
                <nav :class="footerNavClass" :style="footerNavCssStyle">
                    <slot name="footer"></slot>
                </nav>
            </slot>
        </div>
        <div :class="['close-panel', isMobile ? 'mobile' : 'desktop']" @click="closePanel">
            <i :class="['fi', isMobile ? 'fi-rr-cross' : 'fi-rr-angle-right']"></i>
        </div>

        <confirm-dialog
            v-if="isConfirmVisible"
            :title="closeDialogTitle"
            :message="closeDialogMessage"
            :confirm-button-style="closeDialogConfirmButtonStyle"
            :confirm-button-text="closeDialogConfirmButtonText"
            :cancel-button-text="closeDialogCancelButtonText"
            @confirm="handleConfirm"
            @cancel="handleCancel"/>
    </div>
</template>

<script>
import ConfirmDialog from "../organisms/ConfirmDialog.vue";
import {isCurrentUserTeacher} from "../../services/RoleService";

export default {
    name: 'SlideoutContent',
    components: {ConfirmDialog},
    props: {
        footerNavClass: {
            type: String,
            required: false,
            default: "position-sticky nav navbar-light bg-gray-100 bottom-0 right-0 px-md-4 py-1 py-3 gap-2 justify-content-end"
        },
        footerNavCssStyle: {
            type: String,
            required: false,
            default: "max-width: 1024px; width: 100%",
        },
        closeConfirmation: {
            type: Boolean,
            default: false
        },
        closeDialogTitle: {
            type: String,
            default: trans('general.dialog.slideout.title')
        },
        closeDialogMessage: {
            type: String,
            default: ''
        },
        closeDialogConfirmButtonText: {
            type: String,
            default: trans('general.dialog.confirm_close')
        },
        closeDialogConfirmButtonStyle: {
            type: String,
            default: 'danger'
        },
        closeDialogCancelButtonText: {
            type: String,
            default: trans('general.dialog.cancel_close')
        },
    },
    data() {
        return {
            isConfirmVisible: false,
            isTeacherView: false,
            isMobile: true,
            slideoutPanelContent: null,
            resizeTimer: null,
        }
    },
    methods: {
        showConfirmDialog() {
            this.isConfirmVisible = true;
        },
        handleConfirm() {
            this.isConfirmVisible = false;
            this.$emit('close');
        },
        handleCancel() {
            this.isConfirmVisible = false;
        },
        closePanel() {
            if (this.closeConfirmation) {
                this.showConfirmDialog()
            } else {
                this.$emit('close');
                this.$emit('closePanel');
            }
        },
        updateWidth() {
            clearTimeout(this.resizeTimer);

            this.resizeTimer = setTimeout(() => {
                if(window.innerWidth - this.slideoutPanelContent.offsetWidth < 50) {
                    this.isMobile = true;
                } else {
                    this.isMobile = false;
                }
            }, 100);
        },
    },
    mounted() {
        this.slideoutPanelContent = this.$el.parentElement.querySelector('.slideout-panel-content');
        this.updateWidth();

        window.addEventListener('resize', this.updateWidth);
        isCurrentUserTeacher().then(isTeacher => {
            this.isTeacherView = isTeacher;
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWidth);
    },
}
</script>
<style scoped>
.teacher-mobile-padding {
  @media (max-width: 992px) {
    padding-bottom: 65px !important;
  }
}
</style>
